import {Component, Input, OnChanges } from '@angular/core';
import {GadgetApiService, GadgetsService} from '@signature-it/ngx-generic/services';
import {ProgressGadget} from "../progress/progress.gadget";
import {MultipleBarsRestApiGadget} from "../multiple-bars-rest-api/multiple-bars.gadget";
import {ListTextGadget} from "../list-text/list-text.gadget";
import {MultipleBarsGadget} from "../multiple-bars/multiple-bars.gadget"

@Component({
    selector: 'feedback-statistics-gadget',
    templateUrl: './feedback-statistics.gadget.html',
    styleUrls: ['./feedback-statistics.gadget.scss'],
    standalone: false
})
export class FeedbackStatisticsGadget implements OnChanges {

    @Input() currentItem;
    feedbackQuestions: any;

    constructor(protected gadgetApiSvc: GadgetApiService) {}


    ngOnChanges(changes): void {
        if (changes.currentItem && changes.currentItem.currentValue) {
            if(this.currentItem.form_collection_var && this.currentItem.pid) {
                this.setData()
            } else {
                this.feedbackQuestions = null;
            }
        }
    }

    setData() {
        this.gadgetApiSvc.GetFeedbackQuestions(this.currentItem.form_collection_var, this.currentItem.pid).subscribe(data => {
            this.feedbackQuestions = data;
        });
    }
}
